import React, { useState, useEffect, useRef } from "react";
import MPSBarLoader from "../components/MPSBarLoader";

const FeelingToday = () => {
    return (
      <div style={{ textAlign: "center", marginBottom: "3rem", maxWidth: "42rem", marginLeft: "auto", marginRight: "auto" }}>
        <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>
          How are you feeling today?
        </h2>
        <p style={{ color: "#6c757d", fontSize: "1.125rem" }}>
          Share your symptoms with our AI assistant, and we'll connect you with the right specialists for your needs.
        </p>
      </div>
    );
  };

const SymptomAssistant = ({ setSpecialists }) => {
    const [ messages, setMessages ] = useState([
        {
            author: "bot",
            message: "Hi. Thank you for visiting Fakeeh Care. We hope that we can be of help to you today.",
            time: new Date().toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })
        },
        {
          author: "bot",
          message: "Please share any symptoms you may be experiencing - we will try our best to connect you to a specialist who can assist with your needs.",
          time: new Date().toLocaleTimeString("en-GB", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false,
            })
      }
    ])
    const [textInput, setTextInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [threadId, setThreadId] = useState(null);

    const messageContainerRef = useRef(null);

    useEffect(() => {
      if (messageContainerRef.current) {
        messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
      }
    }, [messages]);

    const onAddMessage = async (event) => {
        event.preventDefault();
        if (!textInput) return;
        setLoading(true);
        setMessages([...messages, { author: "user", message: textInput, time: new Date().toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          }) }])
        setTextInput("");
        try {
            const data = threadId ? { prompt: textInput, threadId } : { prompt: textInput };
            const res = await fetch("https://testapi.mypatientspace.com/api/a/specialist-matching", {
                method: "POST", 
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(data) 
              });
              const result = await res.json(); 
              setMessages((prevState) => [...prevState, { author: "bot", message: result.response, time: new Date().toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              }) }])
              if (!threadId && result.threadId) {
                setThreadId(result.threadId);
              }
              if (!!result.specialists?.length) {
                setSpecialists(result.specialists);
              }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

  return (
    <div>
      <FeelingToday />
        <form
        onSubmit={onAddMessage}
        style={{
            borderRadius: "1rem",
            overflow: "hidden",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
        }}
        className="mx-5"
        >
        <div
            style={{
            background: "linear-gradient(to right, #4a90e2, #357ab7)",
            padding: "1rem",
            color: "white",
            }}
        >
            <h3 style={{ fontWeight: "500", margin: 0 }}>Symptom Assistant</h3>
        </div>

        <div
            ref={messageContainerRef}
            style={{
            height: "400px",
            overflowY: "auto",
            padding: "1.5rem",
            }}
        >
            {messages.map((msg, index) => msg.author === "bot" ? (
            <div key={index} style={{ display: "flex", justifyContent: "flex-start" }} className="my-2">
            <div
                style={{
                maxWidth: "80%",
                padding: "1rem",
                borderRadius: "1rem",
                backgroundColor: "#f3f4f6",
                borderTopLeftRadius: "0",
                }}
            >
                <p>{msg.message}</p>
                <p style={{ fontSize: "0.75rem", opacity: "0.7", marginTop: "0.25rem" }}>{msg.time}</p>
            </div>
            </div>
            ) : (
                <div key={index} style={{ display: "flex", justifyContent: "flex-end" }} className="my-2">
            <div
                style={{
                maxWidth: "80%",
                padding: "1rem",
                borderRadius: "1rem",
                backgroundColor: "#4a90e2",
                color: "white",
                borderTopRightRadius: "0",
                }}
            >
                <p>{msg.message}</p>
                <p style={{ fontSize: "0.75rem", opacity: "0.7", marginTop: "0.25rem" }}>{msg.time}</p>
            </div>
            </div>
            ))}

        </div>

        <div
            style={{
            padding: "1rem",
            borderTop: "1px solid #f3f4f6",
            backgroundColor: "white",
            }}
        >
            {loading && 
            <div className="my-2">
                <MPSBarLoader width="100" widthUnit="%"/>
            </div>}
            <div style={{ display: "flex", gap: "0.5rem" }}>
            <input
                style={{
                flex: 1,
                height: "40px",
                borderRadius: "0.375rem",
                border: "1px solid #d1d5db",
                padding: "0.5rem 1rem",
                fontSize: "1rem",
                outline: "none",
                }}
                onChange={({target}) => setTextInput(target.value)}
                value={textInput}
                placeholder="Describe your symptoms..."
            />
            <button
                style={{
                height: "40px",
                padding: "0.5rem 1rem",
                backgroundColor: "#4a90e2",
                color: "white",
                borderRadius: "0.375rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                cursor: "pointer",
                }}
                disabled={loading}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m22 2-7 20-4-9-9-4Z"></path>
                <path d="M22 2 11 13"></path>
                </svg>
            </button>
            </div>
        </div>
        </form>
    </div>
  );
};

export default SymptomAssistant;
